import { validatePermission } from 'actions';
import { cooperplaceApi } from 'services/api';

export const ATTENDANCE_RESTRICTION = 'ATENDIMENTO_EXCLUSIVO_TORRE_CONTROLE';
export const RESTRICTION_MESSAGE =
  'Seu acesso permite atendimento somente pela Torre de Controle. Abra Veículos e selecione o candidato.';
export const POLICY_ERROR =
  'Não foi possível confirmar seu acesso ao atendimento. Atualize a página e tente novamente.';

// O cache orienta os botões. A autorização é consultada novamente antes de salvar.
export const isAttendanceRestricted = () => validatePermission(ATTENDANCE_RESTRICTION);

export async function readAttendancePolicy(companyId) {
  try {
    const { data } = await cooperplaceApi.get('/control-tower/attendance-policy');
    if (
      !Number.isSafeInteger(data?.companyId) ||
      data.companyId <= 0 ||
      (companyId !== undefined && data.companyId !== companyId) ||
      typeof data.requiresControlTowerContext !== 'boolean'
    )
      throw new Error(POLICY_ERROR);
    return data;
  } catch {
    throw new Error(POLICY_ERROR);
  }
}

export async function assertAttendanceAccess(record) {
  const policy = await readAttendancePolicy(record?.companyId);
  if (policy.requiresControlTowerContext && !record?.token) {
    throw new Error(RESTRICTION_MESSAGE);
  }
  // A assinatura, o autor e a elegibilidade são revalidados pelo servidor ao salvar.
}
